var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-loaction-wrapper"},[_c('div',{staticClass:"location-widget",on:{"click":function($event){return _vm.openMap()}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }